export default {
  sectionTitle: {
    id: 'buyback_reassurance_section_title',
    defaultMessage: 'The fast, easy, and free way to cash in on old tech.',
  },
  getOfferTitle: {
    id: 'buyback_reassurance_get_offer_title',
    defaultMessage: 'Get an offer',
  },
  getOfferDescription: {
    id: 'buyback_reassurance_get_offer_description',
    defaultMessage:
      'Get an offer from a professional refurbisher in about 2 minutes.',
  },
  shipForFreeTitle: {
    id: 'buyback_reassurance_ship_for_free_title',
    defaultMessage: 'Ship for free',
  },
  shipForFreeDescription: {
    id: 'buyback_reassurance_ship_for_free_description',
    defaultMessage:
      'Transfer your data and ship your device for free within 21 days.',
  },
  getPaidTitle: {
    id: 'buyback_reassurance_get_paid_title',
    defaultMessage: 'Get paid',
  },
  getPaidDescription: {
    id: 'buyback_reassurance_get_paid_description',
    defaultMessage: 'Receive a direct deposit within 5 business days.',
  },
}
